// src/utils/preloadImages.js
import mdcvisual from '../assets/mdcvisual.webp';

const imagesToPreload = [
  mdcvisual,
  // Add other images imported via JS here
];

export const preloadImages = () => {
  imagesToPreload.forEach((imageSrc) => {
    const img = new Image();
    img.src = imageSrc;
  });
};
